import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useGetUsersQuery } from "../redux/services/userManagementApi";
import { RootState } from "../redux/store";

export interface OrgUser {
  _id: string;
  name: string;
  email?: string;
  status: string;
  role: string;
}

interface V2UserEntry {
  user: { id: string; name: string; email?: string; phone?: string };
  role: string;
  status: string;
}

export const useOrgUsersList = (options?: { skip?: boolean }) => {
  const orgCode = useSelector((state: RootState) => state.auth.user?.org_code);

  const orgUsersPayload = useMemo(
    () => ({
      current_page: 1,
      limit: 1000,
      is_org_request: !!orgCode,
      client_codes: [] as string[],
      role: [] as string[],
      status: ["active"] as string[],
    }),
    [orgCode]
  );

  const query = useGetUsersQuery(orgUsersPayload, {
    skip: options?.skip,
  });

  const users: OrgUser[] = useMemo(() => {
    const list =
      (query.data as { user_list?: V2UserEntry[] } | undefined)?.user_list ??
      [];
    return list.map((entry) => ({
      _id: entry?.user?.id,
      name: entry?.user?.name,
      email: entry?.user?.email,
      status: entry?.status,
      role: entry?.role,
    }));
  }, [query.data]);

  return { ...query, users, activeUsers: users };
};
